import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../../store/modalSlice";
import { refundTableColumnsConfig } from "./refundTableColumnsConfig";

import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";
import { selectRefundState } from "../../../store/refund/refundFilterSlice";
import {
  selectRefunds,
  useGetRefundListQuery,
} from "../../../services/refund/refundApiSlice";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";
const statusMap = {
  Approve: 15,
  Reject: 21,
};

export const RefundTablePage = () => {
  const appliedFilters = useSelector(selectRefundState);
  const { isSuccess, isLoading, isFetching } =
    useGetRefundListQuery(appliedFilters);

  const tableData = useSelector(selectRefunds);
  const navigate = useNavigate();

  const handleNavigateToDetail = useCallback(
    (refundId) => {
      navigate(`/refunds/${refundId}`);
    },
    [navigate],
  );
  const columnDefs = useMemo(
    () => refundTableColumnsConfig(handleNavigateToDetail),
    [handleNavigateToDetail],
  );

  return isSuccess ? (
    <Table data={tableData} columns={columnDefs} loading={isLoading || isFetching} />
  ) : (
    <CategoryPageSkeleton />
  );
};
